import React, { useState } from "react";
import help_icon from "../../images/sidebar_icon/help_icon.svg";
import InvestmentHeaderBox1 from "../../components/InvestmentHeaderBox1";
import "../../styles/profile.css";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import pen_inner from "../../images/my_profile/pen_inner.svg";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";

// Functional component for the Home page
const FaqAdd = () => {
  const location = useLocation();
  const mandateData = location.state;
  const navigate = useNavigate()
  return (
    <div className="container-fluid page_background ">
      <div className="page-inner-content mb-3">
        <div className="page_inner_content_box">
             <div style={{display: "flex"}} >
          <Link style={{marginBottom: "8px",marginTop: "3px"}} onClick={()=>navigate(-1)}>
                  <FontAwesomeIcon
                    icon={faAngleLeft}
                    className="color me-2"
                    style={{ fontSize: "24px", color: "#2C2D3A", paddingRight: "10px" }}
                  />
                </Link>
          
                      <h5 className="mb-4 main-heading-title"> Nach Details </h5>

          
                        </div>
          
          <div className="card redeam_bottom_card mapping-details-box investor-status-box">
            <div className="table-responsive bankDetailTable">
              <table className="table_transaction">
                <thead>
                  <tr>
                    <th scope="col">Bank Name</th>
                    <th scope="col">Account Type</th>
                    <th scope="col">Account No.</th>
                    <th scope="col">Nach Status</th>
                    <th scope="col">Start Date</th>
                    <th scope="col">End Date</th>
                    <th scope="col">Nach Limit</th>
                  </tr>
                </thead>
                <tbody>
                  {mandateData?.length > 0 ? (
                    mandateData?.map((mandate, index) => (
                      <tr>
                        <td>{mandate?.bank_name || "-"}</td>
                        <td>{mandate.acc_type?mandate.acc_type =="SB" ?"Saving" : "Current"  : "-"}</td>
                        <td>{mandate?.bank_account_number || "-"}</td>
                        <td>{mandate?.status || "-"}</td>
                        <td>
                          {mandate?.start_date
                            ? new Date(mandate?.start_date).toLocaleDateString(
                                "en-GB"
                              )
                            : "-"}
                        </td>
                        <td>
                          {mandate?.end_date
                            ? new Date(mandate?.end_date).toLocaleDateString(
                                "en-GB"
                              )
                            : "-"}
                        </td>
                        <td>{mandate?.amount || "-"}</td>
                      </tr>
                    ))
                  ) : (
                    <>
                      <tr style={{ height: "100px" }}>
                        <td colSpan="12" className="no-data-message text-center">
                          No Mandate Account in your list.
                        </td>
                      </tr>
                    </>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FaqAdd;
